module.exports = __webpack_public_path__ + "media/images/empresa/emp_cred-1ab2a9feefd1f53417d653b705f5cbf7.png";